// @ts-nocheck
import React from 'react';
import styles from '../styles/gameStyles';
import { NineSliceButton } from '../components/ui';

/**
 * TitleScreen - タイトル画面コンポーネント
 *
 * Phase 1: magic-spirit.jsxからの画面分離
 *
 * @param {Object} props
 * @param {boolean} props.isMobile - モバイル表示かどうか
 * @param {function} props.onStartGame - ゲーム開始時のコールバック
 * @param {function} props.onHelpClick - 遊び方ボタンクリック時のコールバック
 */
const TitleScreen = ({
  isMobile,
  onStartGame,
  onHelpClick,
}) => {
  return (
    <div style={{
      ...styles.container,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      gap: isMobile ? '24px' : '32px',
    }}>
      <h1 style={{
        ...styles.title,
        fontSize: isMobile ? '32px' : '48px',
        textAlign: 'center',
        marginBottom: 0,
      }}>
        ✨ Magic Spirit ✨
      </h1>
      <p style={{
        color: '#a0a0a0',
        fontSize: isMobile ? '14px' : '18px',
        margin: 0,
        textAlign: 'center',
      }}>
        スピリットウェイヴァーよ、戦いの時だ
      </p>
      <NineSliceButton
        onClick={onStartGame}
        padding={isMobile ? '16px 48px' : '20px 64px'}
        minWidth={isMobile ? 180 : 220}
        style={{
          fontSize: isMobile ? '18px' : '22px',
          marginTop: isMobile ? '16px' : '24px',
        }}
      >
        ゲーム開始
      </NineSliceButton>
      {onHelpClick && (
        <button
          onClick={onHelpClick}
          style={{
            background: 'rgba(107, 158, 255, 0.15)',
            border: '1px solid rgba(107, 158, 255, 0.4)',
            borderRadius: '8px',
            color: '#a0c0ff',
            fontSize: isMobile ? '14px' : '16px',
            padding: isMobile ? '10px 24px' : '12px 32px',
            cursor: 'pointer',
            transition: 'all 0.2s',
          }}
        >
          ❓ 遊び方
        </button>
      )}
      <div style={{ color: '#555', fontSize: '11px', marginTop: isMobile ? '32px' : '48px' }}>
        プロトタイプ版
      </div>
    </div>
  );
};

export default TitleScreen;
